import FieldTypeSelect from './FieldTypeSelect';

export default FieldTypeSelect;
